import { inject, Service } from '@angular/core';
import { AjaxCallService } from './ajax-call';
import { NeoListItem } from '../models/neo-list-item.model';
import { of } from 'rxjs';

@Service()
export class CacheInformationService {

    private ajax = inject(AjaxCallService);

    private errorMessages: NeoListItem<string>[] = [];
    private warningMessages: NeoListItem<string>[] = [];

    getErrorMessages(): Promise<NeoListItem<string>[]> {
        return new Promise<NeoListItem<string>[]>((resolve, reject) => {
            if (this.errorMessages.length > 0) {
                resolve(this.errorMessages);
                return;
            }
            this.ajax.MakeCall<NeoListItem<string>[]>('/Core/PricingErrors').then((data) => {
                this.errorMessages = data;
                resolve(this.errorMessages);
            }, () => {
                resolve([]);
            });
        });
    }

    getWarningMessages(): Promise<NeoListItem<string>[]> {
        return new Promise<NeoListItem<string>[]>((resolve, reject) => {
            if (this.warningMessages.length > 0) {
                resolve(this.warningMessages);
                return;
            }
            this.ajax.MakeCall<NeoListItem<string>[]>('/Core/PricingWarnings').then((data) => {
                this.warningMessages = data;
                resolve(this.warningMessages);
            }, () => {
                resolve([]);
            });
        });
    }
}
